import store from '@/store'

export default {
  /**
   * [historyOption localStory操作]
   * @type {Object}
   * set:设置本地存储
   * get:获取本地存储
   * del:删除本地存储
   * delAll:删除所有本地存储
   */
  historyOpt: {
    /**
     * [setHistory 设置本地缓存]
     * @param {[String]} name   [缓存属性名称]
     * @param {[All]} params [缓存属性值]
     */
    setHistory(name, params) {
      let hisName = name
      let hisParams = params
      if (!hisName) return false
      if (!hisParams) return false
      if (Object.prototype.toString.call(params) == '[object Object]') {
        hisParams = JSON.stringify(hisParams)
      }
      window.localStorage.setItem(hisName, hisParams)
    },
    getHistory(name) {
      let params = window.localStorage.getItem(name)
      if (params) {
        return params
      } else {
        return false
      }
    },
    delHistory(name) {
      window.localStorage.removeItem(name)
    },
    delAllHistory() {
      window.localStorage.clear()
    },
  },
} //end
